import React from 'react';
import { getImageUrl } from '../QuestionDataMappers';
import { COLORS } from '../QuestionChartConfig';
import { EMOJI_SETS } from '../../EvaluationScaleConfig';

const DetailsList = ({ question }) => {
  const results = question.results || [];
  const total = results.reduce((sum, item) => sum + Number(item.value), 0);

  const isStars = question.responseFormat === 'stars';
  const starChoices = (question.questionChoicesAttributes || []).filter(
    c => !c._destroy && c.label !== 'Sin responder'
  );
  const maxStars = starChoices.length || 5;

  return (
    <div className="survey-result-details-list">
      {results.map((item, idx) => {
        const pct = total > 0 ? ((Number(item.value) / total) * 100).toFixed(0) : '0';
        const imageUrl = getImageUrl(item);
        const itemColor = COLORS[idx % COLORS.length];

        let emoji = null;
        if (question.responseFormat === 'emojis') {
          const sortedChoices = (question.questionChoicesAttributes || [])
            .filter(c => !c._destroy)
            .sort((a, b) => a.position - b.position);
          const n = sortedChoices.length;
          const emojis = EMOJI_SETS[n] || EMOJI_SETS[5];
          const choice = sortedChoices.find(c => {
            const nameStr = c.label || String(c.position);
            return nameStr === item.name;
          });
          const choiceIdx = choice ? sortedChoices.indexOf(choice) : -1;
          emoji = choiceIdx !== -1 ? emojis[choiceIdx] : null;
        }

        const isStarItem = isStars && item.name !== 'Sin responder';
        const starCount = isStarItem ? parseInt(item.name, 10) || 0 : 0;

        return (
          <div key={item.id || item.name} className="details-list-row">
            <div className="details-list-left">
              {!isStarItem && <span className="survey-result-color-dot" style={{ backgroundColor: itemColor }} />}
              {isStarItem && (
                <span className="mr-2 d-inline-flex" style={{ gap: '2px', fontSize: '15px', userSelect: 'none' }}>
                  {Array.from({ length: maxStars }, (_, i) => ({
                    id: `star-${item.name}-${i}`,
                    isFilled: i < starCount
                  })).map(star => (
                    <span
                      key={star.id}
                      style={{
                        color: star.isFilled ? itemColor : '#cbd5e0',
                        lineHeight: 1
                      }}
                    >
                      {star.isFilled ? '★' : '☆'}
                    </span>
                  ))}
                </span>
              )}
              {imageUrl && <img src={imageUrl} alt={item.name} className="survey-result-details-img" />}
              {!imageUrl && emoji && (
                <span className="mr-2" style={{ fontSize: '18px' }}>
                  {emoji}
                </span>
              )}
              <span className="details-list-name">{item.name}</span>
            </div>
            <div className="details-list-right">
              <div className="details-list-pct">{pct}%</div>
              <div className="details-list-count">{item.value} resp.</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DetailsList;
